import { createContext, useEffect, useReducer, useRef } from 'react';
import moment from 'moment';

import ContentManager from 'src/componentes/content-manager';
import http from 'src/services/httpService';
import SplashScreen from 'src/componentes/SplashScreen';
import { userLoggedIn, moduleFetched } from 'src/actions/users';
import { useDispatch } from 'react-redux';
import authStorage from 'src/services/authStorage';
import errorHandler from 'src/utils/error-handler';

import AvisoMFA from 'src/paginas/AvisoMFA';
import defaultMessages from 'src/lang/default.json';
import { setCurrentPathname } from 'src/services/httpServiceManager';
import { TIPO_LOGIN, UNKNOWN_PATHNAME } from 'src/utils/constants';
import ConfigApp from 'src/services/configApp';
import OnboardingModal from 'src/paginas/OnboardingGame/OnboardingModal';

import 'moment/locale/tr';
import 'moment/locale/ar';
moment.updateLocale('ar', {
  postformat: (str) => str,
});
import 'moment/locale/pt-br';
import 'moment/locale/nl';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/de';

const initialAuthState = {
  loginAlreadyTriggered: false,
  isAuthenticated: false,
  isInitialised: false,
  user: null,
  resources: null,
  module: null,
  modules: [],
  addons: [],
  terms: null,
  isApp: false,
  configurations: null,
};

export const setSession = (jwt, isExternalAccess = false, mfaJwt = null) => {
  if (jwt) {
    if (isExternalAccess) authStorage.setExternalAccessToken(jwt.accessToken);
    else authStorage.setAccessToken(jwt.accessToken);

    authStorage.setRefreshToken(jwt.refreshToken);
    authStorage.setTokenExpirationTime(jwt.tokenExpirationTime);

    http.defaults.headers.common.Authorization = `Bearer ${jwt.accessToken}`;

    if (mfaJwt) {
      authStorage.setMFAToken(mfaJwt.token);
    }
  } else {
    if (isExternalAccess) authStorage.removeExternalAccessToken();
    else authStorage.removeAccessToken();

    authStorage.removeRefreshToken();
    authStorage.removeTokenExpirationTime();
    delete http.defaults.headers.common.Authorization;

    setCurrentPathname(UNKNOWN_PATHNAME);
  }
};

export const getSession = () => {
  authStorage.clearAllStorage();

  const accessToken = authStorage.getAccessToken();
  const refreshToken = authStorage.getRefresToken();
  const tokenExpirationTime = authStorage.getTokenExpirationTime();
  const externalAccessToken = authStorage.getExternalAccessToken();

  return {
    accessToken,
    refreshToken,
    tokenExpirationTime,
    externalAccessToken,
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIALISE': {
      const {
        isAuthenticated,
        user,
        resources,
        module,
        modules,
        addons,
        terms,
        aceitouTermosUso,
        respondeuPesquisaNps,
        moduloInteligenciaArtificial,
        excluido,
        utilizandoAdfs,
        hybridAuthenticationEnabled,
        identityProviders,
        imagemLogo,
        configurations,
        reCaptchaSiteKey,
        loginAlreadyTriggered = false,
        decimalSeparator,
        thousandsSeparator,
        isLogout,
        respondeuPesquisaCSAT,
        visualizouNovidadesVersao,
      } = action.payload;
      return {
        ...state,
        isAuthenticated,
        loginAlreadyTriggered: state.loginAlreadyTriggered
          ? true
          : loginAlreadyTriggered,
        isInitialised: true,
        user,
        resources,
        module,
        modules,
        addons,
        terms,
        aceitouTermosUso,
        respondeuPesquisaNps,
        moduloInteligenciaArtificial,
        excluido,
        utilizandoAdfs,
        hybridAuthenticationEnabled,
        identityProviders,
        imagemLogo,
        configurations,
        reCaptchaSiteKey,
        decimalSeparator,
        thousandsSeparator,
        isLogout,
        respondeuPesquisaCSAT,
        visualizouNovidadesVersao,
      };
    }
    case 'LOGIN': {
      const {
        user,
        resources,
        module,
        modules,
        addons,
        terms,
        aceitouTermosUso,
        respondeuPesquisaNps,
        moduloInteligenciaArtificial,
        excluido,
        configurations,
        decimalSeparator,
        thousandsSeparator,
        respondeuPesquisaCSAT,
        visualizouNovidadesVersao,
      } = action.payload;

      return {
        ...state,
        isAuthenticated: !excluido,
        loginAlreadyTriggered: true,
        user,
        resources,
        module,
        modules,
        addons,
        terms,
        aceitouTermosUso,
        respondeuPesquisaNps,
        moduloInteligenciaArtificial,
        excluido,
        configurations,
        decimalSeparator,
        thousandsSeparator,
        isLogout: false,
        respondeuPesquisaCSAT,
        visualizouNovidadesVersao,
      };
    }
    case 'LOGOUT': {
      const { utilizandoAdfs, hybridAuthenticationEnabled, identityProviders } =
        action.payload;

      return {
        ...state,
        isAuthenticated: false,
        respondeuPesquisaNps: true,
        user: null,
        module: null,
        modules: [],
        addons: [],
        utilizandoAdfs,
        hybridAuthenticationEnabled,
        identityProviders,
        isLogout: true,
      };
    }
    case 'SETMODULE': {
      const { module } = action.payload;
      return {
        ...state,
        isInitialised: true,
        module,
      };
    }
    case 'SETMODULES': {
      const { modules } = action.payload;
      return {
        ...state,
        isInitialised: true,
        modules,
      };
    }
    case 'LOADING': {
      const { isInitialised } = action.payload;
      return {
        ...state,
        isInitialised,
      };
    }
    case 'SETTERMOSUSO': {
      const { aceitouTermosUso } = action.payload;
      return {
        ...state,
        aceitouTermosUso,
      };
    }
    case 'SETPESQUISANPS': {
      const { respondeuPesquisaNps } = action.payload;
      return {
        ...state,
        respondeuPesquisaNps,
      };
    }
    case 'SETPESQUISACSAT': {
      const { respondeuPesquisaCSAT } = action.payload;
      return {
        ...state,
        respondeuPesquisaCSAT,
      };
    }
    case 'SETNOVIDADESVERSAO': {
      const { visualizouNovidadesVersao } = action.payload;
      return {
        ...state,
        visualizouNovidadesVersao,
      };
    }
    case 'SETBRANDIMAGE': {
      const { imagemLogo } = action.payload;
      return {
        ...state,
        imagemLogo,
      };
    }
    default: {
      return { ...state };
    }
  }
};

const AuthContext = createContext({
  ...initialAuthState,
  login: () => {
    Promise.resolve();
  },
  logout: () => {},
  loginAdfs: () => {},
  setTermosUso: async () => {},
  setPesquisaNPS: async () => {},
  setPesquisaCSAT: async () => {},
  getLoginAdfs: () => {},
  loginUnificado: () => {},
  loginAcessoExterno: () => {},
  loginAcessoConsultaExterna: () => {},
  autenticacaoExterna: () => {},
  setVisualizouNovidadesVersao: async () => {},
  getLoginFlow: () => {},
});

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialAuthState);
  const dispatchRedux = useDispatch();

  const clientUrl = window?.location?.origin;
  const wsRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const isAuthenticatedRef = useRef(state.isAuthenticated);

  const closeWebSocket = () => {
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }

    if (wsRef.current) {
      if (wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.close(1000, 'User logged out');
      }
      wsRef.current = null;
    }
  };

  const logoutAdfs = async (isApp = false) => {
    const response = await http.post('/Authentication/LogoutAdfs', {
      isApp: isApp,
    });
    if (response && response.data) window.location.href = response.data;
  };

  const logout = async (isApp = false) => {
    try {
      closeWebSocket();

      setCurrentPathname(UNKNOWN_PATHNAME);
      localStorage.setItem('RELACIONAMENTO-ITENS', JSON.stringify([]));

      const response = await http.post('/Home/Logout', { isApp: isApp });
      const result = response.data;
      if (!result) return;

      setSession(null);
      dispatch({
        type: 'LOGOUT',
        payload: { utilizandoAdfs: result.utilizandoAdfs },
      });

      if (result.utilizandoAdfs == true) {
        logoutAdfs(isApp);
      } else {
        //dispatchRedux(userLoggedOut(result));
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const setupWebSocket = async (userId, retryCount = 0) => {
    const MAX_RETRIES = 5;

    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }

    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      return;
    }

    try {
      const ticketResponse = await http.get('/Ws/Ticket');
      const { ticket } = ticketResponse.data;

      const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

      const apiUrl = ConfigApp.ApiUrl || '';
      let wsHost;

      if (!apiUrl || apiUrl.startsWith('/')) {
        // URL relativa backend no mesmo host do frontend
        wsHost = window.location.host;
      } else {
        try {
          // URL absoluta extrair host corretamente
          wsHost = new URL(apiUrl).host;
        } catch {
          wsHost = window.location.host; // fallback
        }
      }

      const wsUrl = `${wsProtocol}//${wsHost}/ws/user-status?ticket=${ticket}`;
      const ws = new WebSocket(wsUrl);

      ws.onopen = () => {
        ws.send(
          JSON.stringify({
            type: 'SUBSCRIBE',
          })
        );
      };

      ws.onerror = (error) => {
        console.error('Erro WebSocket:', error);
      };

      ws.onclose = () => {
        wsRef.current = null;

        if (isAuthenticatedRef.current && retryCount < MAX_RETRIES) {
          const delay = Math.min(1000 * Math.pow(2, retryCount), 30000);

          reconnectTimeoutRef.current = setTimeout(() => {
            setupWebSocket(userId, retryCount + 1);
          }, delay);
        } else if (retryCount >= MAX_RETRIES) {
          console.error('Máximo de tentativas de reconexão atingido');
        }
      };

      ws.onmessage = async (event) => {
        try {
          const data = JSON.parse(event.data);

          if (data.type === 'USER_DEACTIVATED') {
            isAuthenticatedRef.current = false;
            closeWebSocket();
            await logout();
          }
        } catch (error) {
          console.error('Erro ao processar mensagem WebSocket:', error);
        }
      };

      wsRef.current = ws;
    } catch (error) {
      console.error('Erro ao configurar WebSocket:', error);
    }
  };

  const setUser = (model, isApp = false) => {
    if (!model) return;

    const {
      usuario,
      jwt,
      mfaJwt,
      resources,
      moduloAtual,
      modulosDisponiveis,
      addonsDisponiveis,
      termos,
      appInfoModel,
    } = model;
    const token = {
      accessToken: jwt?.token,
      refreshToken: jwt?.refreshToken,
      tokenExpirationTime: jwt?.expiraTokenMinutos,
    };

    setSession(token, false, mfaJwt);

    const {
      aceitouTermosUso,
      visualizouAlerta,
      visualizouAvisoMFA,
      respondeuPesquisaNps,
      moduloInteligenciaArtificial,
      excluido,
      tiposAnexos,
      locale,
      decimalSeparator,
      thousandsSeparator,
      respondeuPesquisaCSAT,
      visualizouNovidadesVersao,
      visualizouOnboardGame,
      hybridAuthenticationEnabled,
      tipoLogin,
      id,
      utilizandoAdfs,
    } = appInfoModel;

    if (appInfoModel) {
      // TODO: remover este bind do redux, pois não vamos salvar o usuário mais no redux e sim com context api, mas para
      // manter compatibilidade em todo software, vamos fazer o bind do usuário no redux.
      dispatchRedux(userLoggedIn(appInfoModel));
    }
    moment.locale(usuario.idioma);

    if (isApp) {
      let expirationDate = new Date();
      expirationDate.setMinutes(
        expirationDate.getMinutes() + jwt.expiraTokenMinutos
      );
      expirationDate = moment(expirationDate)
        .locale(locale)
        .format('YYYY-MM-DD HH:mm:ss');
      const redirectURL = `actioapp://main?accessToken=${jwt.token}&expiration=${expirationDate}&language=${locale}`;
      window.location.href = redirectURL;
    }

    dispatch({
      type: 'LOGIN',
      payload: {
        user: usuario,
        resources,
        module: moduloAtual,
        modules: modulosDisponiveis,
        addons: addonsDisponiveis,
        terms: termos,
        aceitouTermosUso,
        visualizouAlerta,
        visualizouAvisoMFA,
        respondeuPesquisaNps: respondeuPesquisaNps && !isApp,
        moduloInteligenciaArtificial,
        excluido,
        respondeuPesquisaCSAT: respondeuPesquisaCSAT && !isApp,
        configurations: {
          tiposAnexos,
        },
        decimalSeparator,
        thousandsSeparator,
        visualizouNovidadesVersao,
      },
    });

    if (!isApp && usuario?.id) {
      setTimeout(() => {
        setupWebSocket(usuario.id);
      }, 1000);
    }

    if (
      !utilizandoAdfs &&
      (visualizouAvisoMFA == null || (visualizouAvisoMFA == false && !isApp))
    ) {
      ContentManager.addContent(<AvisoMFA />);
    }

    if (id != 1 && !visualizouOnboardGame && !isApp) {
      const tipoAcessoSSO =
        (hybridAuthenticationEnabled &&
          utilizandoAdfs &&
          (tipoLogin.id == TIPO_LOGIN.SENHA ||
            tipoLogin?.id == TIPO_LOGIN.SSO)) ||
        (utilizandoAdfs && !hybridAuthenticationEnabled);

      setTimeout(() => {
        ContentManager.addContent(
          <OnboardingModal tipoAcessoSSO={tipoAcessoSSO} />
        );
      }, 0);
    }
  };

  const getLoginAdfs = async (isApp, idp) => {
    try {
      const base = ConfigApp.ApiUrl || '';
      const url =
        `${base}/Authentication/LoginAdfs` +
        `?isApp=${!!isApp}` +
        `&idpEntityId=${encodeURIComponent(idp || '')}`;

      window.location.assign(url);
    } catch (error) {
      console.error('Erro ao iniciar ADFS:', error);
      throw error;
    }
  };

  const getLoginFlow = async (email) => {
    const response = await http.post('/Home/GetLoginFlow', {
      email,
    });

    const data = await response.data;
    return data;
  };

  const loginAdfs = (model, isApp) => {
    setUser(model, isApp);
  };

  const loginUnificado = (token, codigo, MFAToken) => {
    return new Promise((resolve, reject) => {
      http
        .post('/Home/LoginUnificado', { token, codigo, MFAToken })
        .then((response) => {
          const data = response.data;
          const model = { ...data };

          setUser(model);
          resolve(model);
        })
        .catch((error) => reject(error));
    });
  };

  const autenticacaoExterna = async (token) => {
    const response = await http.post('/Home/AutenticacaoExterna', { token });
    const model = { ...response.data };
    setUser(model);
  };

  const login = async (email, password, code, captchaToken, MFAToken) => {
    const response = await http.post('/Home/NewLogin', {
      email,
      senha: password,
      codigo: code,
      urlCliente: clientUrl,
      tokenCaptcha: captchaToken,
      MFAToken,
    });

    const data = await response.data;

    setUser(data);
  };

  const loginAcessoConsultaExterna = async (
    token,
    codigo,
    objetoId,
    tipoId
  ) => {
    const response = await http.post('/Home/LoginAcessoConsutaExterna', {
      token,
      codigo,
      objetoId,
      tipoId,
    });
    const model = { ...response.data };
    setUser(model);
  };

  const loginAcessoExterno = async () => {
    const response = await http.post('/Home/LoginAcessoExterno');
    const model = { ...response.data };
    setUser(model);
  };

  const setModule = async (newModule) => {
    dispatch({
      type: 'LOADING',
      payload: {
        isInitialised: false,
      },
    });
    const response = await http.post('/Home/TrocarModulo', {
      moduloModel: newModule,
    });
    const { jwt, moduloAtual, modulosDisponiveis } = response.data;

    // TODO: remover este bind do redux, pois não vamos salvar o usuário mais no redux e sim com context api, mas para
    // manter compatibilidade em todo software, vamos fazer o bind do usuário no redux.
    dispatchRedux(moduleFetched(moduloAtual));

    dispatch({
      type: 'SETMODULE',
      payload: {
        module: moduloAtual,
      },
    });

    dispatch({
      type: 'SETMODULES',
      payload: {
        modules: modulosDisponiveis,
      },
    });

    setSession({
      accessToken: jwt.token,
      refreshToken: jwt.refreshToken,
      tokenExpirationTime: jwt.expiraTokenMinutos,
    });

    if (document.getElementById('actio-recaptcha'))
      document.getElementById('actio-recaptcha').style.visibility = 'hidden';
  };

  const setTermosUso = async (accept) => {
    try {
      await http.post('/Colaborador/AlterarTermosUso', {
        aceitar: accept,
      });

      dispatch({
        type: 'SETTERMOSUSO',
        payload: {
          aceitouTermosUso: accept,
        },
      });
    } catch (err) {
      errorHandler(err);
    }
  };

  const setPesquisaNPS = async (model) => {
    try {
      await http.post('/PesquisaNps/Salvar', {
        model: model,
      });

      dispatch({
        type: 'SETPESQUISANPS',
        payload: {
          respondeuPesquisaNps: true,
        },
      });
    } catch (err) {
      errorHandler(err);
    }
  };

  const setPesquisaCSAT = async (model) => {
    try {
      await http.post('/PesquisaCSAT/Salvar', {
        model: model,
      });

      dispatch({
        type: 'SETPESQUISACSAT',
        payload: {
          respondeuPesquisaCSAT: true,
        },
      });
    } catch (err) {
      errorHandler(err);
    }
  };

  const setBrandImage = async (imgLogo) => {
    dispatch({
      type: 'SETBRANDIMAGE',
      payload: {
        imagemLogo: imgLogo,
      },
    });
  };

  const setVisualizouNovidadesVersao = async (visualizouNovidadesVersao) => {
    try {
      await http.post('/Colaborador/AlterarAlertaNovidadesVersao', {
        visualizou: visualizouNovidadesVersao,
      });

      dispatch({
        type: 'SETNOVIDADESVERSAO',
        payload: {
          visualizouNovidadesVersao: visualizouNovidadesVersao,
        },
      });
    } catch (err) {
      errorHandler(err);
    }
  };

  useEffect(() => {
    const initialise = async () => {
      try {
        let locale = navigator.language;
        const clientUrl = window?.location?.origin;
        const clientUrlFull = window?.location?.href;
        const currentSession = getSession();
        const { accessToken } = currentSession;
        const isConsultaExternaAllowed =
          authStorage.isConsultaExternaAllowed(accessToken);

        if (!isConsultaExternaAllowed) {
          setSession(null);

          dispatch({
            type: 'INITIALISE',
            payload: {
              isAuthenticated: false,
              user: null,
              resources: defaultMessages,
              module: null,
              modules: [],
              addons: [],
              terms: null,
            },
          });

          logout();

          return;
        }

        if (accessToken && authStorage.isValidToken(accessToken)) {
          if (document.getElementById('actio-recaptcha'))
            document.getElementById('actio-recaptcha').style.visibility =
              'hidden';
          const tokenHasLanguage = authStorage.tokenHasLanguage(accessToken);
          if (tokenHasLanguage) setSession(currentSession);
          const response = await http.post('/Home/Me', {
            clientUrl,
            clientUrlFull,
          });
          const {
            usuario,
            resources,
            moduloAtual,
            modulosDisponiveis,
            termos,
            appInfoModel,
            reCaptchaSiteKey,
            addonsDisponiveis,
          } = response.data;

          const {
            aceitouTermosUso,
            respondeuPesquisaNps,
            moduloInteligenciaArtificial,
            excluido,
            tiposAnexos,
            decimalSeparator,
            thousandsSeparator,
            jwt,
            respondeuPesquisaCSAT,
            visualizouNovidadesVersao,
            utilizandoAdfs,
            hybridAuthenticationEnabled,
            visualizouOnboardGame,
            tipoLogin,
            id,
            isApp,
          } = appInfoModel;

          const imagemLogo = appInfoModel.configuracao.imagemLogo;
          if (!tokenHasLanguage) {
            const token = {
              accessToken: jwt?.token,
              refreshToken: jwt?.refreshToken,
              tokenExpirationTime: jwt?.expiraTokenMinutos,
            };

            setSession(token, false);
          }

          moment.locale(usuario.idioma);

          // TODO: remover este bind do redux, pois não vamos salvar o usuário mais no redux e sim com context api, mas para
          // manter compatibilidade em todo software, vamos fazer o bind do usuário no redux.
          dispatchRedux(userLoggedIn(appInfoModel));

          dispatch({
            type: 'INITIALISE',
            payload: {
              isAuthenticated: !excluido,
              loginAlreadyTriggered: true,
              user: usuario,
              resources,
              module: moduloAtual,
              modules: modulosDisponiveis,
              addons: addonsDisponiveis,
              terms: termos,
              aceitouTermosUso,
              respondeuPesquisaNps,
              moduloInteligenciaArtificial,
              excluido,
              imagemLogo,
              respondeuPesquisaCSAT,
              configurations: {
                tiposAnexos,
              },
              reCaptchaSiteKey: reCaptchaSiteKey,
              decimalSeparator,
              thousandsSeparator,
              visualizouNovidadesVersao,
              utilizandoAdfs,
              hybridAuthenticationEnabled,
            },
          });

          if (!isApp && usuario?.id) {
            setTimeout(() => {
              setupWebSocket(usuario.id);
            }, 1000);
          }

          if (id != 1 && !visualizouOnboardGame && !isApp) {
            const tipoAcessoSSO =
              (hybridAuthenticationEnabled &&
                utilizandoAdfs &&
                (tipoLogin?.id == TIPO_LOGIN.SENHA ||
                  tipoLogin?.id == TIPO_LOGIN.SSO)) ||
              (utilizandoAdfs && !hybridAuthenticationEnabled);

            ContentManager.addContent(
              <OnboardingModal tipoAcessoSSO={tipoAcessoSSO} />
            );
          }
        } else {
          const response = await http.post('/Home/GetResource', { locale });
          const {
            messages,
            utilizandoAdfs,
            reCaptchaSiteKey,
            hybridAuthenticationEnabled,
            identityProviders,
          } = response.data;
          dispatch({
            type: 'INITIALISE',
            payload: {
              isAuthenticated: false,
              user: null,
              resources: { messages },
              module: null,
              modules: [],
              addons: [],
              terms: null,
              utilizandoAdfs: utilizandoAdfs,
              hybridAuthenticationEnabled: hybridAuthenticationEnabled,
              identityProviders: identityProviders,
              reCaptchaSiteKey: reCaptchaSiteKey,
            },
          });
        }
      } catch (err) {
        dispatch({
          type: 'INITIALISE',
          payload: {
            isAuthenticated: false,
            user: null,
            resources: defaultMessages,
            module: null,
            modules: [],
            addons: [],
            terms: null,
          },
        });
        logout();
      }
    };

    initialise();
  }, []);

  useEffect(() => {
    return () => {
      closeWebSocket();
    };
  }, []);

  useEffect(() => {
    isAuthenticatedRef.current = state.isAuthenticated;
  }, [state.isAuthenticated]);

  if (!state.isInitialised) {
    return <SplashScreen />;
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        login,
        logout,
        setModule,
        setTermosUso,
        setPesquisaNPS,
        setPesquisaCSAT,
        loginAdfs,
        getLoginAdfs,
        setBrandImage,
        loginUnificado,
        loginAcessoExterno,
        loginAcessoConsultaExterna,
        autenticacaoExterna,
        setVisualizouNovidadesVersao,
        getLoginFlow,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
